import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito conocimientos previos de electricidad?',
    a: 'No. La colección está diseñada desde cero para alguien que nunca ha tocado una instalación eléctrica. El Tomo 1 empieza explicando qué es cada palanca del cuadro eléctrico.'
  }, {
    q: '¿Es peligroso hacer esto sin ser electricista?',
    a: 'El 90% de los trabajos se hacen con el IGA bajado y verificando con el buscapolos. No tocás cables bajo tensión. El Tomo 1 dedica un capítulo completo al protocolo de seguridad.'
  }, {
    q: '¿En qué formato recibo los libros?',
    a: 'En formato PDF digital de alta calidad. Recibirás el acceso en tu email en menos de 5 minutos después del pago. Compatible con cualquier dispositivo.'
  }, {
    q: '¿Funciona para instalaciones antiguas?',
    a: 'Sí. Dedicamos secciones específicas a instalaciones antiguas sin tierra y con diferenciales viejos, las más comunes en España.'
  }, {
    q: '¿Qué diferencia hay entre la Básica y la Profesional?',
    a: 'La Básica te enseña a resolver averías y ahorrar dinero. La Profesional incluye además El Acelerador de Ingresos con el que podés convertir ese conocimiento en dinero real cobrando a vecinos y clientes.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tenés 30 días de garantía completa. Si por cualquier razón no estás satisfecho, te devolvemos el 100% sin preguntas ni formularios.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="w-full bg-white py-20 px-4" data-id="element-71">
      <div className="max-w-3xl mx-auto" data-id="element-72">
        <div className="text-center mb-12" data-id="element-73">
          <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-74">
            Preguntas frecuentes
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mt-6 leading-tight" data-id="element-75">
            Resolvemos Tus Dudas
          </h2>
        </div>

        <div className="space-y-4" data-id="element-76">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-77">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-5 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-78">
                <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-79">
                  ❓ {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-gray-500 shrink-0" data-id="element-80" /> : <ChevronDown className="text-gray-500 shrink-0" data-id="element-81" />}
              </button>
              <AnimatePresence data-id="element-82">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-83">
                    <div className="p-5 bg-white text-gray-700 font-medium border-t border-gray-200" data-id="element-84">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}